/**
 * 公开邮件服务配置（Web3Forms）
 * 注册地址：https://web3forms.com
 * 使用收件邮箱 252202670@qq.com 注册后，将邮件中的 access_key 填入下方
 */
export const WEB3FORMS_ACCESS_KEY = "8f5eac7d-f422-4750-86eb-8b661a58d80c";

export const CONTACT_FORM_SUBJECT = "贸宝官网 - 联系我们表单";
